import { render, staticRenderFns } from "./FaIconPicker.vue?vue&type=template&id=0a6222f4&scoped=true&"
import script from "./FaIconPicker.vue?vue&type=script&lang=js&"
export * from "./FaIconPicker.vue?vue&type=script&lang=js&"
import style0 from "./FaIconPicker.vue?vue&type=style&index=0&id=0a6222f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6222f4",
  null
  
)

export default component.exports